


import { Loader } from "@googlemaps/js-api-loader";

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; 
const loader = new Loader({
apiKey
,

version: "weekly",
libraries: ["places"],
});


 const useGoogleLoader = () => {
return loader;
};

export default useGoogleLoader;

export const geocodeAddress = (address) => {
  return new Promise((resolve, reject) => {
    if (!window.google || !window.google.maps) {
      reject("Google Maps JS SDK not loaded.");
      return;
    }

    const service = new window.google.maps.places.PlacesService(document.createElement('div'));

    const request = {
      query: address,
      fields: ['geometry'],
    };

    service.findPlaceFromQuery(request, (results, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && results.length > 0) {
        const location = results[0].geometry.location;
        resolve([location.lng(), location.lat()]);
      } else {
        console.error("Places API failed:", status);
        resolve(null);
      }
    });
  });
};
